import React, {FC, memo} from "react";
import {DbTemplate} from "./Email";
import {
    GetMjmlTemplateByIdQuery,
    MailDataType,
    TemplateType,
    useGetMjmlTemplateByIdQuery,
} from "../../../generated/graphql";
import MjmlLoader from "../../../views/MjmlPreview/MjmlLoader/MjmlLoader";
import {TextBlockDraft, useTextBlockPreview} from "../../../views/MjmlPreview/ResolvedPreview/useTextBlockPreview";
import ResolvedPreviewBar from "../../../views/MjmlPreview/ResolvedPreview/ResolvedPreviewBar";
import {NotifySelection} from "./SendMailHandlers/CourseBookingTypeSelector";
import css from "./Email.less";

type EmailPreviewProps = {
    dbTemplate: DbTemplate;
    mailDataType: MailDataType;
    /** Ausgewählte IDs (bei Kurs genau eine Kurs-ID). */
    ids: Array<string>;
    /** Ungespeicherter Entwurf aus dem Editor; fehlt er, gilt die gespeicherte Vorlage. */
    draft?: TextBlockDraft;
    notifySelection?: Array<NotifySelection>;
};

const EmailPreview: FC<EmailPreviewProps> = ({dbTemplate, mailDataType, ids, draft, notifySelection}) => {
    const {templateType, id, subject, headerText, footerText, signature} =
        dbTemplate.data?.template ?? {};

    // Vorschau mit ersetzten Variablen (Plan 2026-09-02 § 3.2), immer auf dem Entwurf (Q5).
    const textBlockPreview = useTextBlockPreview({
        enabled: true,
        templateId: id,
        mailDataType,
        ids,
        draft: draft ?? {subject, headerText, footerText, signature},
        notifyBookings: notifySelection?.includes("notifyBookings"),
        notifyWaitlist: notifySelection?.includes("notifyWaitlist"),
        notifyCancelations: notifySelection?.includes("notifyCancelations"),
    });
    const mailjetTemplateId =
        templateType === TemplateType.FreeText ||
        templateType === TemplateType.NoTemplate
            ? "4250298"
            : "2046014";

    const {
        data: mjmlTemplateData,
        loading: mjmlTemplateLoading,
        error: mjmlTemplateError,
    } = useGetMjmlTemplateByIdQuery({
        variables: {templateId: mailjetTemplateId},
    });

    const mjmlTemplate:
        | GetMjmlTemplateByIdQuery["getEmailTemplateById"]
        | undefined = mjmlTemplateData?.getEmailTemplateById;

    if (!mjmlTemplate || !id) {
        return <div>{"Loading..."}</div>;
    }

    return (
        <div className={css.mjmlPreview}>
            <ResolvedPreviewBar preview={textBlockPreview} />
            <MjmlLoader
                variables={{subject, headerText, footerText, signature}}
                mjmlTemplate={mjmlTemplate.Data}
                loading={mjmlTemplateLoading}
                dbTemplateId={id}
                resolvedTextBlocks={textBlockPreview.resolvedTextBlocks}
                showVariableNames={textBlockPreview.showVariableNames}
            />
        </div>
    );
};

export default memo(EmailPreview);
